var _a, _b;
import generatorForm from "./generator-form";
var program = generatorForm.program, format = generatorForm.format, name = generatorForm.name, goal = generatorForm.goal, cropMarks = generatorForm.cropMarks;
var generatorFormInitialValues = (_a = {},
    _a[program.name] = "opzp",
    _a[format.name] = "billboard_big_single",
    _a.projects = [
        (_b = {},
            _b[name.name] = "",
            _b[goal.name] = "",
            _b.date = {
                from: null,
                to: null,
            },
            _b.year = null,
            _b),
    ],
    _a.debetAll = 0.00,
    _a.contributionFund = 0.00,
    _a.contributionSubject = 0.00,
    _a.sponsorSelect = null,
    _a.programSupport = null,
    _a.image = {
        file: null,
        src: null,
        name: null,
    },
    _a[cropMarks.name] = "yes",
    _a.stepActive = false,
    _a);
// const generatorFormInitialValues = {
//   [program.name]: "opzp",
//   [format.name]: "billboard_big_single",
//   projects: [
//     {
//       [name.name]: "ahoj",
//       [goal.name]: "ako sa mas",
//       date: {
//         from: "2022-03-22",
//         to: "2022-03-22",
//       },
//       year: "2022",
//     },
//   ],
//   image: {
//     file: null,
//     src: null,
//     name: "",
//   },
//   [cropMarks.name]: "yes",
//   stepActive: false,
// };
export default generatorFormInitialValues;
